//FIX ME: pc, mo 공통 유틸로 추상화
const CATEGORY_KEY_BY_NAME = {
  ['전체 랭킹']: 'TOTAL',
  ['패션의류']: 'FASHION_CLOTHES',
  ['패션잡화']: 'FASHION_ACCESSORIES',
  ['뷰티']: 'BEAUTY',
  ['식품']: 'FOOD',
  ['스포츠/레저/자동차']: 'SPORT_LEISURE_CAR',
  ['출산/육아']: 'CHILD_BIRTH',
  ['가구/인테리어']: 'INTERIOR',
  ['생활/건강']: 'LIFE',
  ['가전/디지털']: 'DIGITAL',
  ['여행/티켓/e쿠폰']: 'TRAVEL_TICKET_COUPON',
  ['해외직구']: 'OVERSEA_DIRECT_PURCHASE',
} as const;

type GetDetailPageUrlProps = {
  domain: 'pc' | 'mw';
  isRisingKeyword: boolean;
  categoryName?: keyof typeof CATEGORY_KEY_BY_NAME;
  currentDate?: string;
  total?: number;
};

const getDetailPageUrl = ({
  domain,
  isRisingKeyword,
  categoryName,
  currentDate,
  total,
}: GetDetailPageUrlProps): string => {
  const isCategoryDetail = !isRisingKeyword && categoryName;

  const params: Record<string, string> = {
    domain,
    type: 'detail',
    rising: isCategoryDetail ? 'false' : 'true',
    page: '0',
  };

  if (isCategoryDetail && categoryName) {
    params.category = CATEGORY_KEY_BY_NAME[categoryName];
    if (currentDate) params.date = currentDate;
    if (typeof total === 'number') params.total = total.toString();
  }

  return `?${new URLSearchParams(params).toString()}`;
};

export default getDetailPageUrl;
